import React from 'react';
import styled from 'styled-components';

import Icon from '../../../../Icon/Icon';

import { controllerTokens } from '../../../../../tokens/components/Controller/tokens';
import { colorTokens } from '../../../../../tokens/globals/tokens';

export const ErrorText = styled.span`
  color: ${controllerTokens.ErrorFontColorBaseDefault};
  font-size: ${controllerTokens.ErrorFontSizeDefault};
  font-weight: ${controllerTokens.ErrorFontWeightDefault};
  line-height: ${controllerTokens.ErrorFontLeadingDefault};
`;

const ErrorMarkWrapper = styled.i`
  align-items: center;
  background: ${colorTokens.GlobalFeedbackNegativeIntensity70};
  border-radius: 50%;
  color: white;
  display: inline-flex;
  height: 18px;
  font-family: inherit;
  justify-content: center;
  margin-right: 8px;
  vertical-align: -2px;
  width: 18px;
`;

export const ErrorMark = () => (
  <ErrorMarkWrapper>
    <Icon type="warning" />
  </ErrorMarkWrapper>
);

const ControllerError = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <ErrorText id={props.id}>
    <ErrorMark />
    {props.children}
  </ErrorText>
);

export default ControllerError;
